// SPDX-License-Identifier: LicenseRef-Proprietary
// Copyright (c) 2025 Mann Contractual Management Ltd

const fontWeights = {
  body: 400,
  heading: 800,
  bold: 700,
}

export default fontWeights
